import ticket from "../../assets/images/icons/customIcons/ticket.svg";
import dashboard from "../../assets/images/icons/customIcons/dashboard.svg";
import question from "../../assets/images/icons/customIcons/invocom-question-icon.svg";
import channel from "../../assets/images/icons/channel.svg";
import blog from "../../assets/images/icons/customIcons/blog-icon.svg";
import todo from "../../assets/images/icons/customIcons/invocom-todo.svg";
import lead from "../../assets/images/icons/customIcons/leads.svg";
import setting from "../../assets/images/icons/customIcons/setting.svg";
import meetings from "../../assets/images/icons/customIcons/meeting.svg";
import chat from "../../assets/images/icons/customIcons/chat.svg";
import users from "../../assets/images/icons/customIcons/multiusers.svg";
import bot from "../../assets/images/icons/customIcons/bot.svg";
import reporting from "../../assets/images/icons/customIcons/reporting.svg";
import SingleUser from "../../assets/images/icons/customIcons/singleUser.svg";
import slack from "../../assets/images/icons/customIcons/slack-icon.svg";
import hubspot from "../../assets/images/icons/customIcons/hubspot-icon.svg";
let menu;
menu = [
  {
    id: "home",
    title: "Dashboard",
    icon: (
      <img
        loading="lazy"
        src={dashboard}
        alt=""
        style={{ height: "20px", width: "20px" }}
      />
    ),
    roles: ["ADMIN", "SUPER_ADMIN", "AGENT", "SUB_ADMIN"],
    navLink: "/home",
  },
  {
    id: "todos",
    title: "Todos",
    icon: (
      <img
        loading="lazy"
        src={todo}
        alt=""
        style={{ height: "20px", width: "20px" }}
      />
    ),
    roles: ["ADMIN", "SUPER_ADMIN", "AGENT", "SUB_ADMIN"],
    navLink: "/todos",
  },
  {
    id: "tickets",
    title: "Tickets",
    icon: (
      <img
        loading="lazy"
        src={ticket}
        alt=""
        style={{ height: "20px", width: "20px" }}
      />
    ),
    roles: ["ADMIN", "SUPER_ADMIN", "AGENT", "SUB_ADMIN"],
    navLink: "/tickets",
  },
  {
    id: "leads",
    title: "Leads",
    icon: (
      <img
        loading="lazy"
        src={lead}
        alt=""
        style={{ height: "20px", width: "20px" }}
      />
    ),
    roles: ["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"],
    navLink: "/leads",
  },
  {
    id: "chats",
    title: "Chats",
    icon: (
      <img
        loading="lazy"
        src={chat}
        alt=""
        style={{ height: "20px", width: "20px" }}
      />
    ),
    roles: ["ADMIN", "SUPER_ADMIN", "AGENT", "SUB_ADMIN"],
    navLink: "/chats",
  },

  {
    id: "users",
    title: "Users",
    icon: (
      <img
        loading="lazy"
        src={users}
        alt=""
        style={{ height: "20px", width: "20px" }}
      />
    ),
    roles: ["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"],
    children: [
      {
        id: "admins",
        title: "Admins",
        navLink: "/user/admins",
        roles: ["SUPER_ADMIN"],
      },
      {
        id: "all-users",
        title: "All Users",
        navLink: "/users",
        roles: ["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"],
      },
    ],
  },
  {
    id: "meetings",
    title: "Meetings",
    icon: (
      <img
        loading="lazy"
        src={meetings}
        alt=""
        style={{ height: "20px", width: "20px" }}
      />
    ),
    roles: ["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"],
    navLink: "/meetings",
  },
  {
    id: "questions",
    title: "Questions",
    icon: (
      <img
        loading="lazy"
        src={question}
        alt=""
        style={{ height: "20px", width: "20px" }}
      />
    ),
    roles: ["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"],
    navLink: "/questions",
  },
  {
    id: "blogs",
    title: "Blogs",
    icon: (
      <img
        loading="lazy"
        src={blog}
        alt=""
        style={{ height: "20px", width: "20px" }}
      />
    ),
    roles: ["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"],
    navLink: "/blogs",
  },
  // {
  //   id: "code",
  //   title: "Code",
  //   icon: (
  //     <img
  //       loading="lazy"
  //       src={setting}
  //       alt=""
  //       style={{ height: "20px", width: "20px" }}
  //     />
  //   ),
  //   roles: ["SUPER_ADMIN"],
  //   navLink: "/code",
  // },
  {
    id: "reporting",
    title: "Reporting",
    icon: (
      <img
        loading="lazy"
        src={reporting}
        alt=""
        style={{ height: "20px", width: "20px" }}
      />
    ),
    roles: ["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"],
    navLink: "/reporting",
  },
  {
    id: "integrations",
    title: "Integrations",
    icon: (
      <img
        loading="lazy"
        src={channel}
        alt=""
        style={{ height: "20px", width: "20px" }}
      />
    ),
    roles: ["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"],
    children: [
      {
        id: "website",
        title: "Website",
        navLink: "/integrations/website",
        roles: ["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"],
        icon: (
          <img
            loading="lazy"
            src={SingleUser}
            alt=""
            style={{ height: "20px", width: "20px" }}
          />
        )
      },
      {
        id: "slack",
        title: "Slack",
        navLink: "/integrations/slack",
        roles: ["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"],
        icon: (
          <img
            loading="lazy"
            src={slack}
            alt=""
            style={{ height: "20px", width: "20px" }}
          />
        )
      },
      {
        id: "hubspot",
        title: "Hubspot",
        navLink: "/integrations/hubspot",
        roles: ["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"],
        icon: (
          <img
            loading="lazy"
            src={hubspot}
            alt=""
            style={{ height: "20px", width: "20px" }}
          />
        )
      },
    ],
  },
  {
    id: "channels",
    title: "Channels",
    icon: (
      <img
        loading="lazy"
        src={channel}
        alt=""
        style={{ height: "20px", width: "20px" }}
      />
    ),
    roles: ["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"],
    navLink: "/channels",
  },
  {
    id: "bot",
    title: "Bot Settings",
    icon: (
      <img
        loading="lazy"
        src={bot}
        alt=""
        style={{ height: "20px", width: "20px" }}
      />
    ),
    roles: ["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"],
    navLink: "/bots",
  },
  {
    id: "setting",
    title: "Profile Settings",
    icon: (
      <img
        loading="lazy"
        src={setting}
        alt=""
        style={{ height: "20px", width: "20px" }}
      />
    ),
    roles: ["ADMIN", "SUPER_ADMIN", "AGENT", "SUB_ADMIN"],
    navLink: "/setting",
  },
];
export default menu;
